export default [
    //回款认领
    {
        path: '/moneyBack_claim',
        component: () => import( '@/views/loud/moneyBack/moneyBack_claim.vue'),
        meta: {
            title: '回款认领',
            isTabsPage: true,
            keepAlive:false
        }
    },
    //回款调整
    {
        path: '/moneyBack_trim',
        component: () => import( '@/views/loud/moneyBack/moneyBack_trim.vue'),
    },
    // 回款详情
    {
        path: '/moneyBack_detail',
        component: () => import( '@/views/loud/moneyBack/moneyBack_detail.vue'),
        meta: {
            title: '回款详情',
            isTabsPage: true,
            keepAlive:false
        }
    },
    // 外销回款列表
    {
        path: '/moneyBack_list',
        component: () => import( '@/views/loud/moneyBack/moneyBack_list.vue'),
        meta: {keepAlive: true, title: '回款列表（外）',
            isTabsPage: true
        }
    },
    {
        path: '/payment-list',
        component: () => import( '@/views/loud/moneyBack/payment-list.vue'),
        meta: {keepAlive: true, title: '回款列表(元析)',
            isTabsPage: true
        }
    },
    {
        path: '/payment-details',
        component: () => import( '@/views/loud/moneyBack/payment-details.vue'),
        meta: {keepAlive: true, title: '回款详情',
            isTabsPage: true
        }
    },
    {
        path: '/monthlyCollectionList',
        component: () => import( '@/views/loud/moneyBack/monthlyCollectionList.vue'),
        meta: {keepAlive: true, title: '销售回款报表',
            isTabsPage: true
        }
    },
    // 外销回款认领列表
    {
        path: '/moneyClaim_list',
        component: () => import( '@/views/loud/moneyBack/moneyClaim_list.vue'),
        meta: {keepAlive: true, title: '回款已记账(外)',
            isTabsPage: true
        }
    },
    // 内销回款列表
    {
        path: '/moneyBack_domestic_list',
        component: () => import( '@/views/loud/moneyBack/moneyBack_domestic_list.vue'),
        meta: {
            title: '回款列表(内)',
            isTabsPage: true,
            keepAlive:false
        }
    },
	// 订单回款
	{
	    path: '/orderMoneyBack',
	    component: () => import( '@/views/loud/moneyBack/orderMoneyBack.vue'),
	},
    {
        path: '/moneyBack-Yx',
        component: () => import( '@/views/loud/moneyBack/moneyBackYx.vue'),
        meta: {
            keepAlive: true,
            title: '回款列表(元析)',
            isTabsPage: true
        }
    },
]
